module.exports = __webpack_public_path__ + "img/logo_full.8e5e82dd.svg";